import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchUserApiScopesTE = <E = CF.API.ApiError>(
  { userId, keyType = 'API_KEY' }: { userId: string; keyType?: CF.API.ApiKeys.KeyType },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Scopes.ScopesResponse> =>
  fetchTE<CF.API.Scopes.ScopesResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/scopes?key_type=${keyType === 'API_KEY' ? 'app_specific_key' : 'personal_access_token'}`,
      method: 'GET',
    },
    onRejected,
  );
